/**
 * Responsible for responsiveness of sizeguide
 * @module sizeguide
 */

import $ from 'jquery';

// Responsive Tables
function splitTable(original) {
  original.wrap('<div class=\'table-wrapper\' />');
  const copy = original.clone();
  copy.find('td:not(.pinit), th:not(.pinit)').css('display', 'none');
  copy.removeClass('responsive').addClass('cloned');
  original.closest('.table-wrapper').append(copy);
  copy.wrap('<div class=\'pinned\' />');
  original.wrap('<div class=\'scrollable\' />');
  original.find('td.pinit, th.pinit').css('display', 'none');
  original.css({ 'margin-left': copy.width() });
  // copy.css({'width': copy.width() - original.width()});
}

function unsplitTable(original) {
  original.find('td.pinit, th.pinit').css('display', 'table-cell');
  original.closest('.table-wrapper').find('.pinned').remove();
  original.css({ 'margin-left': 0 });
  original.unwrap();
  original.unwrap();
}

export default function sizeguideTable() {
  let switched = false;
  function updateTables() {
    if (($(window).width() < 767) && !switched) {
      switched = true; // its because this is always going to be overwritten
      splitTable($('table.responsive')); // see if this is better or .each
    } else if (switched && ($(window).width() > 767)) {
      switched = false;
      $('table.responsive').each((i, element) => {
        unsplitTable($(element));
      });
    }
  }

  $(window).on('load', updateTables);
  updateTables();
  $(window).bind('resize', updateTables);
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/sizeguide.js